import React from "react";

import Label from "./Label";

import { orderStatus, Roles } from "./config";

export function formatDate(dt) {
  const options = {
    weekday: "short",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };

  const d = new Date(dt).toLocaleDateString("tr-TR", options);

  return d;
}

export function calcDateDiff(dt) {
  const nowDate = new Date();
  const dtDate = new Date(dt);
  let diffInMilliSeconds = Math.abs(nowDate - dtDate) / 1000;

  // calculate days
  const days = Math.floor(diffInMilliSeconds / 86400);
  diffInMilliSeconds -= days * 86400;

  // calculate hours
  let hours = Math.floor(diffInMilliSeconds / 3600) % 24;
  diffInMilliSeconds -= hours * 3600;

  // calculate minutes
  const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
  diffInMilliSeconds -= minutes * 60;

  let difference = "";
  if (days > 0) {
    hours += days * 24;
    //difference += days === 1 ? `${days} gün, ` : `${days} gün, `;
  }

  difference += hours > 0 ? `${hours} saat, ` : ``;

  difference +=
    minutes === 0 || hours === 1 ? `${minutes} dakika` : `${minutes} dakika`;

  return difference;
}

export const loadScript = (src, onLoad) => {
  const script = document.createElement("script");

  script.src = src;
  script.async = true;
  document.body.appendChild(script);
  script.onload = onLoad;
};

export const copyToClipboard = (str) => {
  const el = document.createElement("textarea");
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

export function YaMapApiLoader(
  apiKey = process.env.REACT_APP_YANDEX_JS_KEY,
  lang = "tr_TR"
) {
  let yaMapApi;

  const scriptSrc = `https://api-maps.yandex.ru/2.1/?apikey=${apiKey}&lang=${lang}&onload=yandexMapsAPILoad`;

  if (yaMapApi) {
    return Promise.resolve(yaMapApi);
  }

  return new Promise((resolve, reject) => {
    loadScript(scriptSrc);

    window.yandexMapsAPILoad = (ymaps) => {
      yaMapApi = ymaps;

      resolve(yaMapApi);
    };

    setTimeout(() => {
      if (!window.ymaps) {
        reject(new Error("Loading took too long"));
      }
    }, 5000);
  });
}

export function getStatusLabel(statusType) {
  const map = {
    [orderStatus.CREATED]: {
      text: "Aktif",
      color: "success",
    },
    [orderStatus.CANCELLED]: {
      text: "İptal Edildi",
      color: "error",
    },
    [orderStatus.PREPARED]: {
      text: "Hazırlandı",
      color: "warning",
    },
    [orderStatus.ON_DELIVERY]: {
      text: "Yolda",
      color: "warning",
    },
    [orderStatus.DELIVERED]: {
      text: "Teslim Edildi",
      color: "success",
    },
  };

  const { text, color } = map[statusType] || map[orderStatus.CREATED];

  return <Label color={color}>{text}</Label>;
}

export function ordersPageTitle(role) {
  const map = {
    [Roles.COURIER]: "Siparişlerim",
    [Roles.PICKER]: "Aktif Siparişler",
    [Roles.GETIR_MH]: "Tüm Siparişler",
  };

  return map[role] || "";
}
